import styles from './ContentHeader.module.scss';
import cx from 'classnames';

import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import {
  usePhotoControllerGetUserPhotoQuery,
  UserDto,
} from '@app/store/api/tunedRestApi';
import { PATH } from '@app/index';
import { UserInfo } from '@shared/UserInfo';
import { AccountHeader, SettingsHeader } from '@shared/Header';
import { BalanceInfo } from '@features/index';

type THeaderType = 'user' | 'account' | 'settings';

interface ContentHeaderProps {
  user: UserDto;
}

export const ContentHeader: FC<ContentHeaderProps> = ({ user }) => {
  const location = useLocation();

  const { data: avatar, isLoading: avatarIsLoading } =
    usePhotoControllerGetUserPhotoQuery(undefined, {
      refetchOnMountOrArgChange: true,
    });

  const isSettingsPage = location.pathname === PATH.SETTINGS;
  const isAccountPage = location.pathname === PATH.ACCOUNT;

  let headerType: THeaderType = 'user';

  if (isAccountPage) headerType = 'account';
  if (isSettingsPage) headerType = 'settings';

  return (
    <div
      className={cx(styles.chHeader, {
        [styles.chHeaderAccount]: isAccountPage || isSettingsPage,
      })}
    >
      {headerType === 'user' && (
        <>
          <UserInfo
            avatar={avatar}
            username={user.username ?? ''}
            avatarIsLoading={avatarIsLoading}
            userAccountLink={PATH.ACCOUNT}
          />
          <BalanceInfo />
        </>
      )}
      {headerType === 'account' && (
        <AccountHeader
          avatar={avatar}
          username={user.username ?? ''}
          displayNumber={user.displayNumber}
          avatarIsLoading={avatarIsLoading}
        />
      )}
      {headerType === 'settings' && <SettingsHeader />}
    </div>
  );
};
